export default __webpack_public_path__ + "da52d430b8fa32276f9eb3e797b6165e.png";